module.exports = __webpack_public_path__ + "static/img/100682.ce087323.png";